// extracted by mini-css-extract-plugin
export default {"services":"ServicesList_services__Oh-Px","service":"ServicesList_service__6hR6v"};